import React, { useEffect, useState } from "react";
import { Button, Checkbox, message } from "antd";
import { OPTION_OTHER } from "../../constants/constants";
import { CircleMinus, Edit2Icon } from "lucide-react";
import { RemoveCircle, RemoveCircleOutline } from "@mui/icons-material";

interface MultiSelectCheckboxGroupProps {
  label: string;
  options: string[];
  selected: string[];
  setSelected: any;
  otherInputValue?: string;
  checked: boolean;
  showCheckBox?: boolean;
  setChecked: (checked: boolean) => void;
  setOtherInputValue?: (value: string) => void;
  toggleSelection?: (option: string) => void;
}

const MultiSelectCheckboxGroupWithAddItem: React.FC<MultiSelectCheckboxGroupProps> = ({
  label,
  options = [],
  selected = [],
  otherInputValue,
  setOtherInputValue,
  checked,
  setSelected,
  setChecked,
  toggleSelection,
  showCheckBox = true,
}) => {
  const [allOptions, setAllOptions] = useState<string[]>(options || []);
  const [otherValue, setOtherValue] = useState("");
  const [isAddOther, setIsAddOther] = useState(false)
  const [error, setError] = useState("");


  useEffect(() => {
    if (selected.every((o: string) => options.includes(o))) {
      setIsAddOther(false);
      setOtherValue("")
      setAllOptions(options);
    } else {
      setAllOptions([
        ...options,
        ...selected.filter(item => !options.includes(item))
      ]);
    }
  }, [selected])

  const onAdd = () => {
    if (error) {
      message.warning(error);
      return;
    }

    if (otherValue) {
      setSelected((prev: string[]) => [...prev, otherValue])
      setAllOptions([...allOptions, otherValue])
      setOtherValue("")
    } else {
      message.warning("Enter other value")
    }
  }

  const onRemove = (value: string) => {
    setSelected((prev: string[]) => prev.filter((o: string) => o !== value))
  }

  const onChangeOtherValue = (value: string) => {
    setOtherValue(value);
    validateBrandName(value);
  }

  const validateBrandName = (value: string) => {
    const hasAlphabet = /[A-Za-z]/.test(value);
    if (!hasAlphabet) {
      setError("Must contain at least one alphabetic character.");
    } else if (value.length > 50) {
      setError("Must not exceed 50 characters.");
    } else {
      setError("");
    }
  };

  return (
    <div className="col-span-1">
      {showCheckBox ? (
        <Checkbox
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          className="common-bold-label"
        >
          {label}
        </Checkbox>
      ) : (
        <p className="common-bold-label">{label}</p>
      )}

      {checked && (
        <div className="flex flex-wrap gap-x-2 gap-y-2 mt-[24px]">
          {allOptions?.filter((o: string) => o !== OPTION_OTHER)?.map((option) => (
            <Button
              type="text"
              key={option}
              // onClick={() => (selected.includes(option)) && option === 'Other' ? '' : toggleSelection(option)}
              onClick={() => {
                if (selected.includes(option) && option === "Other") {
                } else {
                  if (option === "None") {
                    setSelected(["None"]); // Clear all, only select 'None'
                  } else {
                    const updatedSelection = selected.includes(option)
                      ? selected.filter((item) => item !== option)
                      : [...selected.filter((item) => item !== "None"), option]; // Remove 'None' if present
                    setSelected(updatedSelection);
                  }
                }
              }}
              className={`flex justify-between cursor-pointer rounded-[30px] ${options.includes(option) ? "px-3" : "pl-3 pr-1"} py-1 text-sm font-normal font-['Inter'] leading-tight  transition${selected.includes(option) ? "text-[#1849a9] " : "text-[#1d2939]"
                }`}
              style={{
                border: `1px solid ${selected.includes(option) ? "#53b1fd" : "#e4e7ec"
                  }`,
                backgroundColor: `${selected.includes(option) ? "#d1e9ff" : ""
                  }`,
              }}
            >
              {option}
              {!options.includes(option) ? (
                <Button icon={<CircleMinus height={14} />} type="text" size="small" shape="circle" onClick={() => onRemove(option)} />
              ) : (
                <></>
              )}
            </Button>
          ))}
          {
            isAddOther ? (
              <div>
                <div
                  className="flex items-center"
                >
                  <input
                    type="text"
                    value={otherValue}
                    onChange={(e) => onChangeOtherValue(e.target.value)}
                    placeholder="Add Other"
                    className="px-3 py-1 border border-gray-300 rounded-l-full text-sm focus:outline-none h-[32px]"
                    autoFocus
                  />
                  <Button
                    htmlType="submit"
                    className="rounded-r-full common-primary-button btn-primary-blue"
                    onClick={() => onAdd()}
                  >
                    Add
                  </Button>
                </div>
                <p className="mt-2 text-xs mx-2 text-red-500">{error}</p>
              </div>
            ) : (
              allOptions.includes(OPTION_OTHER) && !allOptions.includes(otherValue) ? (
                <Button
                  type="text"
                  key={"other"}
                  onClick={() => setIsAddOther(!isAddOther)}
                  className={`cursor-pointer rounded-[30px] px-5 py-1 text-sm font-normal font-['Inter'] leading-tight transition flex items-center gap-2 ${isAddOther ? "text-[#1849a9]" : "text-[#1d2939]"
                    }`}
                  style={{
                    border: `1px solid ${isAddOther ? "#53b1fd" : "#e4e7ec"
                      }`,
                    backgroundColor: `${isAddOther ? "#d1e9ff" : ""}`,
                  }}
                >
                  {isAddOther && (
                    <span className="h-2 w-2 bg-[#1849a9] rounded-full" />
                  )}
                  Other
                </Button>
              ) : (
                <></>
              )
            )
          }
        </div>
      )}
    </div>
  );
};

export default MultiSelectCheckboxGroupWithAddItem;
